// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/vision_project.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/projects/v1/vision_project.proto.
 */
export const file_vision_projects_v1_vision_project: GenFile = /*@__PURE__*/
  fileDesc("Cid2aXNpb24vcHJvamVjdHMvdjEvdmlzaW9uX3Byb2plY3QucHJvdG8SGXByb3Rvcy52aXNpb24ucHJvamVjdHMudjEipgEKDVZpc2lvblByb2plY3QSEgoKcHJvamVjdF9pZBgBIAEoCRIMCgRuYW1lGAIgASgJEhMKC2Rlc2NyaXB0aW9uGAMgASgJEi4KCmNyZWF0ZWRfYXQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIrkDChVWaXNpb25Qcm9qZWN0TGlzdEl0ZW0SEgoKcHJvamVjdF9pZBgBIAEoCRIMCgRuYW1lGAIgASgJEhMKC2Rlc2NyaXB0aW9uGAMgASgJEj0KB215X3JvbGUYBCABKA4yLC5wcm90b3MudmlzaW9uLnByb2plY3RzLnYxLlZpc2lvblByb2plY3RSb2xlEhIKCm93bmVyX25hbWUYBSABKAkSFgoObG9jYXRpb25fY291bnQYBiABKAUSLgoKY3JlYXRlZF9hdBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgIIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASTAoSbG9jYXRpb25fc3VtbWFyaWVzGAkgAygLMjAucHJvdG9zLnZpc2lvbi5wcm9qZWN0cy52MS5WaXNpb25Mb2NhdGlvblN1bW1hcnkSGwoTY292ZXJfdGh1bWJuYWlsX3VybBgKIAEoCRIZChF0b3RhbF9pbWFnZV9jb3VudBgLIAEoBRIYChBnZW5lcmF0aW9uX2NvdW50GAwgASgFIk8KFVZpc2lvbkxvY2F0aW9uU3VtbWFyeRITCgtsb2NhdGlvbl9pZBgBIAEoCRIMCgRuYW1lGAIgASgJEhMKC2ltYWdlX2NvdW50GAMgASgFKrkBChFWaXNpb25Qcm9qZWN0Um9sZRIfChtWSVNJT05fUFJPSkVDVF9ST0xFX1VOS05PV04QABIdChlWSVNJT05fUFJPSkVDVF9ST0xFX09XTkVSEAESIQodVklTSU9OX1BST0pFQ1RfUk9MRV9WSUVXX09OTFkQAhIcChhWSVNJT05fUFJPSkVDVF9ST0xFX0VESVQQAxIjCh9WSVNJT05fUFJPSkVDVF9ST0xFX0ZVTExfQUNDRVNTEARiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.projects.v1.VisionProject
 */
export type VisionProject = Message<"protos.vision.projects.v1.VisionProject"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.VisionProject.
 * Use `create(VisionProjectSchema)` to create a new message.
 */
export const VisionProjectSchema: GenMessage<VisionProject> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_vision_project, 0);

/**
 * @generated from message protos.vision.projects.v1.VisionProjectListItem
 */
export type VisionProjectListItem = Message<"protos.vision.projects.v1.VisionProjectListItem"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: protos.vision.projects.v1.VisionProjectRole my_role = 4;
   */
  myRole: VisionProjectRole;

  /**
   * @generated from field: string owner_name = 5;
   */
  ownerName: string;

  /**
   * @generated from field: int32 location_count = 6;
   */
  locationCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: repeated protos.vision.projects.v1.VisionLocationSummary location_summaries = 9;
   */
  locationSummaries: VisionLocationSummary[];

  /**
   * @generated from field: string cover_thumbnail_url = 10;
   */
  coverThumbnailUrl: string;

  /**
   * @generated from field: int32 total_image_count = 11;
   */
  totalImageCount: number;

  /**
   * @generated from field: int32 generation_count = 12;
   */
  generationCount: number;
};

/**
 * Describes the message protos.vision.projects.v1.VisionProjectListItem.
 * Use `create(VisionProjectListItemSchema)` to create a new message.
 */
export const VisionProjectListItemSchema: GenMessage<VisionProjectListItem> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_vision_project, 1);

/**
 * @generated from message protos.vision.projects.v1.VisionLocationSummary
 */
export type VisionLocationSummary = Message<"protos.vision.projects.v1.VisionLocationSummary"> & {
  /**
   * @generated from field: string location_id = 1;
   */
  locationId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int32 image_count = 3;
   */
  imageCount: number;
};

/**
 * Describes the message protos.vision.projects.v1.VisionLocationSummary.
 * Use `create(VisionLocationSummarySchema)` to create a new message.
 */
export const VisionLocationSummarySchema: GenMessage<VisionLocationSummary> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_vision_project, 2);

/**
 * @generated from enum protos.vision.projects.v1.VisionProjectRole
 */
export enum VisionProjectRole {
  /**
   * @generated from enum value: VISION_PROJECT_ROLE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: VISION_PROJECT_ROLE_OWNER = 1;
   */
  OWNER = 1,

  /**
   * @generated from enum value: VISION_PROJECT_ROLE_VIEW_ONLY = 2;
   */
  VIEW_ONLY = 2,

  /**
   * @generated from enum value: VISION_PROJECT_ROLE_EDIT = 3;
   */
  EDIT = 3,

  /**
   * @generated from enum value: VISION_PROJECT_ROLE_FULL_ACCESS = 4;
   */
  FULL_ACCESS = 4,
}

/**
 * Describes the enum protos.vision.projects.v1.VisionProjectRole.
 */
export const VisionProjectRoleSchema: GenEnum<VisionProjectRole> = /*@__PURE__*/
  enumDesc(file_vision_projects_v1_vision_project, 0);

